var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-content-wrapper gray" }, [
    _c("div", { staticClass: "go-container mypage sub friend-invite" }, [
      _c("div", { staticClass: "go-layout-wrap" }, [
        _c("div", { staticClass: "go-layout-header" }, [
          _c("div", { staticClass: "go-layout-path" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("myPage.common.myPage")))]),
            _vm._v(" "),
            _c("i", { staticClass: "go-icon-16 go-icon-chevron-right" }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("myPage.common.invitePromotion"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "go-layout-title" }, [
            _c(
              "button",
              {
                staticClass: "btn go-btn-icon",
                attrs: {
                  type: "button",
                  "data-toggle": "dropdown",
                  "aria-expanded": "false",
                },
                on: { click: _vm.roueToMyPage },
              },
              [_c("i", { staticClass: "go-icon-24 go-icon-arrow-left" })]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "go-page-header-type2" }, [
              _c("div", { staticClass: "go-page-title" }, [
                _vm._v(_vm._s(_vm.$t("myPage.common.invitePromotion"))),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "go-layout-content" },
          [_c("payment-invite")],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }